module.exports = __webpack_public_path__ + "static/img/01.3b85dfd.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/assets/img/subscribe/01.jpg
// module id = vhe7
// module chunks = 1